<p class="headline-small" mat-dialog-title>{{ "settings.title" | translate }}</p>
<mat-dialog-content>
  <mat-label>{{ "settings.language" | translate }}</mat-label>
  <mat-form-field id="languageSelect" appearance="outline">
    <mat-select [(value)]="selectedLanguage">
      @for (language of availableLanguages; track language) {
        <mat-option [value]="language" (click)="changeLanguage(language)"
                    (keydown.enter)="changeLanguage(language)">
          {{ "settings.languages." + language.label | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (notificationPreferences.length > 0) {
    <div id="notificationPreferences">
      <p class="settings-group-title">{{ "settings.notifications.title" | translate }}</p>
      @for (preference of notificationPreferences; track preference.type) {
        <mat-slide-toggle
          [checked]="preference.enabled"
          [disabled]="preference.updating"
          (change)="updateNotificationPreference(preference, $event.checked)">
          {{ "settings.notifications.types." + preference.type | translate }}
        </mat-slide-toggle>
      }
    </div>
  }
  <p id="version" class="label-small">{{ applicationInfo?.build?.version }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ "settings.close" | translate }}</button>
</mat-dialog-actions>
